import Styles from './ImageEditor.module.scss'
import { Close } from 'blaze-ui/icons'
import { Button } from 'blaze-ui/Button/Button'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Text } from 'blaze-ui/Text/Text'

interface ConfirmDeletionViewProps {
  onCancelDeletion: () => void
  onDismiss: () => void
  close: () => void
}

export const ConfirmDeletionView = ({ onCancelDeletion, onDismiss, close }: ConfirmDeletionViewProps) => (
  <div className={Styles.deletionConfirmPopover}>
    <IconButton
      variant="secondary"
      size="sm"
      icon={Close}
      aria-label="Close"
      onPress={close}
      className={Styles.editTextClose}
    />
    <Text variant="secondary" color="var(--dark-90)" className={Styles.deletionConfirmMessage}>
      This will be removed when you save changes.
    </Text>
    <div className={Styles.deletionConfirmFooter}>
      <Button variant="secondary" size="md" className={Styles.deletionCancelButton} onPress={onCancelDeletion}>
        Cancel Deletion
      </Button>
      <Button
        variant="primary"
        size="md"
        className={Styles.editTextConfirm}
        onPress={onDismiss}
        aria-label="Keep removal and close"
      >
        Confirm
      </Button>
    </div>
  </div>
)
